import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

export const companyDocumentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/documents',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({
        to: '/',
      })
    }
  },
}).lazy(() => import('./documents/documents').then((d) => d.Route))
